export enum ExportJobStatus {
  INITIATED = 'INITIATED',
  CLAIMED = 'CLAIMED',
  COMPLETED = 'COMPLETED',
  ERRORED = 'ERRORED',
}

export interface ExportJob {
  id: string;
  status: ExportJobStatus;
  downloadUrl: string | null;
  errorMessage: string | null;
  fileName: string;
}

export interface InitiateExportResponse {
  jobId: string;
  fileName: string;
  s3Key: string;
}
